export const FOOTER_VISIBILITY_EVENT = 'slotcheck:footer-visibility-change';

export type FooterVisibilityEventDetail = {
  visible: boolean;
};
